<template>
  <v-row no-gutters justify="space-between" class="flex-column flex-md-row my-n2">
    <v-col class="pr-xxl-2 my-2 input_holder col-12 col-xxl-6">
      <!-- Keep it here to disable chrome email autocomplete. It's retarded. I know... -->
      <input id="field" type="text" style="height: 0; width: 0; position: absolute" />
      <label for="current_password">{{ $t('profile.currentPassword') }}</label>
      <v-text-field
        id="current_password"
        v-model="currentPassword"
        solo
        flat
        hide-details="auto"
        type="password"
        placeholder="********"
        autocomplete="off"
        :disabled="disabled"
        :error="!currentPasswordValidation"
        :error-messages="!currentPasswordValidation ? currentPasswordError : ''"
        @keydown="currentPasswordValidation = true"
      />
    </v-col>
    <v-col class="pl-xxl-2 my-2 input_holder col-12 col-xxl-6">
      <label for="new_password">{{ $t('profile.newPassword') }}</label>
      <v-text-field
        id="new_password"
        v-model="$v.password.$model"
        solo
        flat
        hide-details="auto"
        :append-icon="showNewPassword ? '$eyeOpen' : '$eyeClose'"
        :type="showNewPassword ? 'text' : 'password'"
        placeholder="********"
        :error="newPasswordErrors"
        autocomplete="off"
        :error-messages="newPasswordErrorMessage"
        :disabled="disabled"
        @click:append="showNewPassword = !showNewPassword"
      />
    </v-col>
  </v-row>
</template>

<script>
import formValidation from '@/mixins/formValidation';
import passwordValidation from '@/mixins/password-validation';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'UpdatePassword',
  mixins: [formValidation, passwordValidation],
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showNewPassword: false
    };
  },
  validations() {
    let password = {};
    let generatedValidation = this.generatePasswordVuelidation();

    if (this.password.length) {
      password = generatedValidation;
    }

    return {
      password
    };
  },
  methods: {
    ...mapActions({
      setPasswordValidation: 'profile/dashboard/setPasswordValidation',
      setSuccess: 'profile/accountSettings/setSuccess',
      setNewPasswordError: 'forms/updatePassword/setNewPasswordError'
    }),
    reset() {
      this.$v.$reset();
      this.currentPassword = '';
      this.password = '';
      this.setNewPasswordError(false);
    }
  },
  computed: {
    ...mapGetters({
      newPasswordError: 'forms/updatePassword/newPasswordError'
    }),
    currentPassword: {
      get() {
        return this.$store.state.forms.updatePassword.currentPassword;
      },
      set(value) {
        this.$store.commit('forms/updatePassword/updateCurrentPassword', value);
      }
    },
    password: {
      get() {
        return this.$store.state.forms.updatePassword.newPassword;
      },
      set(value) {
        this.$store.commit('forms/updatePassword/updateNewPassword', value);
      }
    },
    currentPasswordValidation: {
      get() {
        return this.$store.state.forms.updatePassword.currentPasswordValidation;
      },
      set(value) {
        this.$store.commit('forms/updatePassword/setCurrentPasswordValidation', value);
      }
    },
    newPasswordErrors() {
      return (this.$v.password && this.$v.password.$invalid) || this.newPasswordError;
    },
    newPasswordErrorMessage() {
      if (this.$v.password && this.$v.password.$invalid) {
        return this.errorMessage;
      }
      if (this.newPasswordError) {
        return this.$t('profile.currentPasswordUsedInHistory');
      } else {
        return '';
      }
    }
  },
  watch: {
    password() {
      this.validateForm(() => {}, 'forms/updatePassword');
      this.setSuccess(false);
    },
    currentPassword() {
      this.setSuccess(false);
    }
  },
  created() {
    this.setPasswordValidation({ prop: 'email', val: this.$auth.user.email });
    this.$eventHub.$on('validateUpdatePassword', done =>
      this.validateForm(done, 'forms/updatePassword')
    );
    this.$eventHub.$on('resetUpdatePassword', () => this.reset());
  },
  destroyed() {
    this.$eventHub.$off('resetUpdatePassword');
    this.$eventHub.$off('validateUpdatePassword');
  }
};
</script>
